import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Collapse",
  "use": "Collapse-usage",
  "viewBox": "0 0 36 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 20\" id=\"Collapse\"><path fill-rule=\"evenodd\" d=\"M18 19.125L0 0h36L18 19.125zm0-7.313l6.75-6.75h-13.5l6.75 6.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol